import { Pipe, PipeTransform } from '@angular/core';
import { SettingService } from '../services/setting.service';

@Pipe({
    name: 'setting',
    pure: false,
})
export class SettingPipe implements PipeTransform {

    protected value;

    constructor(protected settings: SettingService) {
    }

    transform(name: string, defaultValue: string) {
        this.settings.get(name, (value) => {
            this.value = value;
        }, defaultValue);

        return this.value;
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/settings/pipes/setting.pipe.ts